import React, { Suspense, useEffect, useState } from "react";
import "./App.css";
import "./assets/style/custom.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Routing from "./Routes";
import "bootstrap/dist/css/bootstrap.css";
import "./config/font.css";
import LoadingOverlay from "react-loading-overlay-ts";
import { useAppSelector } from "./core/feature/hooks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Company from "../src/core/models/company";
import __favicon from "./assets/images/favicon.svg";

import { ParallaxProvider } from "react-scroll-parallax";
import { i18n } from "./translations/i18n";
import { setLanguage } from "./core/feature/language/languageSlice";
import { useDispatch } from "react-redux";
import moment from "moment";
import TokenLangHandler from "./components/TokenLangHandler";
class RouteChunkErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="flex min-h-screen flex-col items-center justify-center gap-4">
          <p>Unable to load this page.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  let isLoading: boolean = useAppSelector((state) => state.config.loading);
  const company: Company = useAppSelector((state) => state.company.company);
  const language: String = useAppSelector((state) => state.language.language);
  const [lang, setLang] = useState("en");
  const dispatch = useDispatch();
  const [title, setTitle] = useState("Platform Sekolah Pintar");
  function getFaviconEl() {
    return document.getElementById("favicon");
  }

  useEffect(() => {
    // setTitle(company?.name);
    const favicon: any | null = getFaviconEl();
    // favicon.href = company?.logo != null ? company?.logo : closepayLogo;
    favicon.href = __favicon;
    document.title = title;
  }, [company]);

  useEffect(() => {
    if (language == "" || language == undefined) {
      i18n.changeLanguage("en");
      dispatch(setLanguage(lang));
    }
    language == "en" ? moment.locale("en") : moment.locale("id");
  }, [language]);
  return (
    <ParallaxProvider>
      <div className="Appw-full h-screen bg-psp-primary">
        <ToastContainer></ToastContainer>
        <TokenLangHandler />

        <LoadingOverlay className="h-screen" active={isLoading} spinner text="Loading ...">
          <RouteChunkErrorBoundary>
            <Suspense
              fallback={
                <div role="status" aria-live="polite" className="flex min-h-screen items-center justify-center">
                  Loading page...
                </div>
              }
            >
              <Routes>
                {Routing.map((prop: any, index: any) => {
                  // console.log(prop);

                  if (prop.path == "") {
                    return (
                      <Route
                        key={`menu-${index}`}
                        path="/"
                        element={<Navigate to={prop.redirect} replace />}
                      />
                    );
                  } else {
                    return (
                      <Route
                        key={"menu-" + index}
                        path={prop.path}
                        element={<prop.component />}
                      />
                    );
                  }
                })}
              </Routes>
            </Suspense>
          </RouteChunkErrorBoundary>
        </LoadingOverlay>
      </div>
    </ParallaxProvider>
  );
}

export default App;
